module.exports = __webpack_public_path__ + "e5d07baf5b326d386339ae1a0c1269dc.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CA.svg
// module id = se7I
// module chunks = 0